<template>

  <header class="h-[600px] flex flex-col items-center justify-center bg-cover bg-center bg-no-repeat"  :style="{ backgroundImage: 'url(' + require(`@/assets/background.png`) + ')' }">
  
    <div class="flex flex-col items-center my-10 text-center">
      <img class="object-contain w-12/12 " src="@/assets/logo.png" />      
    </div>

  </header>


</template>

<script>
import VueScrollTo from 'vue-scrollto';

export default {
  methods: {
    scrollToForm() {
      VueScrollTo.scrollTo('#formulario', 500, {
        easing: 'ease-in-out',
      });
    },
  },  
}

</script>